<mat-card class="details-card" [class.mobile-layout]="mobileMode$ | async" animated delayed>
    <ng-container *ngIf="showActions && (desktopMode$ | async)">
        <button mat-flat-button linkButton disableRipple class="actions-menu"
                [disabled]="!actions || (loading$ | async)"
                [matMenuTriggerFor]="mobileActionMenu"
                [attr.aria-label]="'Available actions menu'">
            <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
        </button>
        <mat-menu #mobileActionMenu="matMenu" xPosition="before" class="v2-panel">
            <button *ngFor="let action of actions" (click)="doAction(action.action)" mat-menu-item>
                {{ action.title }}
            </button>
        </mat-menu>
    </ng-container>

    <ng-content></ng-content>
</mat-card>

<mat-card #actionsCard *ngIf="showActions && !(desktopMode$ | async)" class="actions-card">
    <mat-card class="actions-card-inner">
        <mat-card-title>{{ 'Actions' }}</mat-card-title>

        <mat-progress-bar mode="query" color="primary" [class.active]="loading$ | async"></mat-progress-bar>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list>
                <ng-container *ngIf="!actions">
                    <ng-container *ngFor="let count of (actionLines | counter)">
                        <template [ngTemplateOutlet]="loadingAction"></template>
                    </ng-container>
                </ng-container>

                <mat-list-item *ngFor="let action of actions"
                               [class.add-hover]="!(loading$ | async)"
                               animated delayed="list" [fadeFrom]="'bottom'">
                    <button mat-flat-button disableRipple [disabled]="loading$ | async" (click)="doAction(action.action)">
                        <app-avatar-block *ngIf="action.svg" [svgIcon]="action.svg">
                            <span avatarTitle>{{ action.title }}</span>
                            <span *ngIf="action?.description" avatarDescription>{{ action.description }}</span>
                        </app-avatar-block>
                        <app-avatar-block *ngIf="action.icon" class="with-icon" [icon]="action.icon">
                            <span avatarTitle>{{ action.title }}</span>
                            <span *ngIf="action?.description" avatarDescription>{{ action.description }}</span>
                        </app-avatar-block>
                        <mat-icon class="highlight-on-hover" [svgIcon]="'v2:fi-br-next'"></mat-icon>
                    </button>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>
</mat-card>

<ng-content select="mat-toolbar"></ng-content>

<ng-template #loadingAction>
    <mat-list-item animated delayed="list" [fadeFrom]="'bottom'">
        <button mat-flat-button disableRipple disabled>
            <app-avatar-block [isLoadingInitialData]="true"></app-avatar-block>
        </button>
    </mat-list-item>
</ng-template>
